export const SESSION_SPANISH = 'usuario_espanol';
export const SESSION_ENGLISH = 'usuario_ingles';
export const SESSION_QUIMIC = 'usuario_quimico';
